import { app } from '../../../../app';
import { Controller } from './access-requests.controller';

app.component('accessRequests', {
    bindings: {
        requests: '<',
    },
    controller: Controller,
    templateUrl: require('./access-requests.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/requests/access-requests.component.js